var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FABB18"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.8 18) scale(1.35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8445 9.10103C15.3675 13.9392 17.4242 15.4018 17.4242 15.4018H1.22217C1.22217 15.4018 3.92251 13.4819 3.92251 6.76073C3.92251 5.23324 4.49138 3.76785 5.50401 2.68772C6.51754 1.60758 7.89202 1 9.3232 1C9.62654 1 9.92808 1.027 10.2233 1.08101M10.8804 18.1022C10.7223 18.3752 10.4953 18.6019 10.2219 18.7595C9.94863 18.9171 9.63869 19 9.3232 19C9.00771 19 8.69777 18.9171 8.42446 18.7595C8.15115 18.6019 7.92407 18.3752 7.766 18.1022M15.624 6.40069C16.3402 6.40069 17.027 6.11619 17.5334 5.60978C18.0398 5.10336 18.3243 4.41652 18.3243 3.70034C18.3243 2.98417 18.0398 2.29733 17.5334 1.79091C17.027 1.2845 16.3402 1 15.624 1C14.9078 1 14.221 1.2845 13.7146 1.79091C13.2082 2.29733 12.9237 2.98417 12.9237 3.70034C12.9237 4.41652 13.2082 5.10336 13.7146 5.60978C14.221 6.11619 14.9078 6.40069 15.624 6.40069Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.53690b693f772df18834d7f2b9ca50c4.svg";
export { ForwardRef as ReactComponent };